export enum EAgentLandingPageType {
  ComparableProperties = 'COMPARABLE_PROPERTIES',
  ContactForm = 'CONTACT_FORM',
  DigitalAd = 'DIGITAL_AD',
}

export const agentLandingPageSampleTokens = {
  [EAgentLandingPageType.ComparableProperties]: 'sample-comparable-properties',
  [EAgentLandingPageType.ContactForm]: 'sample-contact-form',
  [EAgentLandingPageType.DigitalAd]: 'sample-digital-ad',
} as Record<EAgentLandingPageType, string>;

export interface IAgentLandingAgent {
  firstName: string;
  lastName?: string;
  phoneNumber?: string;
  email?: string;
  website?: string;
  licenseNumber?: string;
  pictureUrl?: string;
}

export interface IAgentLandingAgentData {
  firstName: string;
  lastName?: string;
  phoneNumber?: string;
  email?: string;
  website?: string;
  agentDreNumber?: string;
  agentPictureUrl?: string;
  teamLogoUrl?: string;
  companyLogoUrl?: string;
  companyName?: string;
  agentLandingBio?: string;
  secondProfileFirstName?: string;
  secondProfileLastName?: string;
  secondProfileEmailAddress?: string;
  secondProfilePhoneNumber?: string;
  secondProfileWebsite?: string;
  secondProfileLicenseNumber?: string;
  secondProfilePictureUrl?: string;
}

export interface IAgentLandingSeriesPoint {
  date: string;
  value: number;
}

export interface IAgentLandingMarketStats {
  zipCode: string;
  locality: { city?: string; state?: string };
  updatedAt?: string;
  residentialType: number;
  metrics: {
    medianListPrice?: number;
    medianNewListingPrice?: number;
    medianPricePerSquareFoot?: number;
    medianDaysOnMarket?: number;
    averageDaysOnMarket?: number;
    cityAverageDaysOnMarket?: number;
    inventory?: number;
    priceDecreasedPercent?: number;
    priceIncreasedPercent?: number;
    relistedPercent?: number;
    medianRent?: number;
    marketActionIndex?: number;
  };
  marketPosition?: {
    label: string;
    side: 'buyer' | 'balanced' | 'seller';
  };
  narrative?: {
    market?: string;
    price?: string;
    pricePerSquareFoot?: string;
    daysOnMarket?: string;
    inventory?: string;
  };
  series: {
    medianListPrice: IAgentLandingSeriesPoint[];
    medianNewListingPrice: IAgentLandingSeriesPoint[];
    medianPricePerSquareFoot: IAgentLandingSeriesPoint[];
    medianDaysOnMarket: IAgentLandingSeriesPoint[];
    averageDaysOnMarket: IAgentLandingSeriesPoint[];
    inventory: IAgentLandingSeriesPoint[];
    priceDecreasedPercent: IAgentLandingSeriesPoint[];
    priceIncreasedPercent: IAgentLandingSeriesPoint[];
    relistedPercent: IAgentLandingSeriesPoint[];
    medianRent: IAgentLandingSeriesPoint[];
    marketActionIndex: IAgentLandingSeriesPoint[];
  };
}

export type IAgentLandingZipCodeData = IAgentLandingMarketStats;
